import * as actionTypes from '../actionTypes';

const initialState = {
  allData: [],
  descending: true,
  page: 1,
  rowsPerPage: 10,
  sortBy: 'id',
  total: '',
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_NOTIFICATION_REDUCER:
      state = {
        ...state,
        allData: action.payload.data.data,
        descending: action.payload.data.pagination.descending,
        page: action.payload.data.pagination.page,
        rowsPerPage: action.payload.data.pagination.rowsPerPage,
        sortBy: action.payload.data.pagination.sortBy,
        total: action.payload.data.pagination.total,
      }
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
}

export default reducer;
